module.exports = __webpack_public_path__ + "static/img/icon-ellipsis@3x.e5530fb1.png";